<template>
  <div class="providers casino">
    <ul>
      <li style="display: none;" :class="((currentProvider == 'all' ? 'active ' : ''))">
        <a :class="((currentProvider == 'all' ? 'active ' : ''))" href="javascript:;" @click="change('all')">
         Tümü
        </a>
      </li>
      <li :class="((item.name == currentProvider ? 'active ' : '') + item.name)" v-for="(item,key) in providers" :key="key">
        <a :class="((item.name == currentProvider ? 'active ' : '') + item.name)" href="javascript:;" @click="change(item.name)">
          <img v-if="!isMobile" :src="$store.state.main.cdn_url + '/providers/' +  _.toLower(item.name)  + '.png?n'"/>
          <div class="info" v-if="isMobile">
              <div class="name">
                <img width="50" :src="$store.state.main.cdn_url + '/providers/' +  _.toLower(item.name)  + '.png?n'"/>
                {{ item.name | ucFirst }} Gaming
              </div>
          </div>
          <div type="button" class="button" v-if="isMobile">Geçiş Yap</div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default{
    methods:{
      change(provider){
        if(this.isMobile){
          this.$parent.isVisible = false;
        }
        this.$store.dispatch('casino/changeProvider', [provider])
      }
    },
    computed:{
      providers(){
        return this.$store.getters['casino/getProviders'];
      },
      client_id(){
        return process.env.VUE_APP_CLIENT_ID
      },
      currentCategory(){
        return this.$store.getters['casino/getCurrentCategory'];
      },
      currentProvider(){
        return this.$store.getters['casino/getCurrentProvider'];
      },
    },
  }
</script>